import useSWR from "swr";

export default function useParkInfo({slug}) {
    const { data, error, isLoading } = useSWR(`/api/park/${slug}`)
    //console.log(data)
    return {
        data,
        isLoading,
        isError: error
    }
}
